import { useState } from 'react';
import { IconArrowLeft, IconSend, IconCalendarOff } from '@tabler/icons-react';
import { Link } from '@tanstack/react-router';
import { PageHeader, Page } from '@hana/shell';
import { Button, StateView, useToast, type ScreenState } from '@hana/ui';
import { DUTY_DAYS, DUTY_OT, DUTY_WEEKS, dutyOtPct, type DutyWeek } from './duty';
import { useT } from '@hana/i18n';
import './i18n';
import s from './duty.module.css';

// Mint-TMS-Phone · khung 2 "Lịch trực của tôi" (390). Chỉ đọc; xin đổi ca = toast giả lập (không ghi).
// Phụ cấp trực theo ca ẩn (money=hide của board). Thanh tab dưới do shell.
function readState(): ScreenState | null {
  const v = new URLSearchParams(location.search).get('state');
  return v === 'loading' || v === 'empty' || v === 'error' || v === 'noperm' ? v : null;
}

export function DutyPhonePage() {
  const toast = useToast();
  const t = useT();
  const state = readState() ?? 'ready';
  const [wk, setWk] = useState<DutyWeek>('A');
  const days = DUTY_DAYS[wk];
  return (
    <Page>
      <PageHeader
        lead={<Link to="/ezy/tms" className={s.back} aria-label="Quay lại"><IconArrowLeft size={18} stroke={2} aria-hidden="true" /></Link>}
        title="Lịch trực của tôi"
        noFind
      />
      <StateView
        state={state}
        icon={<IconCalendarOff size={26} stroke={1.8} />}
        title={state === 'empty' ? 'Chưa có lịch trực' : undefined}
        action={state === 'error' ? <Button variant="secondary" onClick={() => location.reload()}>{t('common.retry')}</Button> : undefined}
        skeleton={[1, 2, 3].map((k) => <div key={k} className={s.skel} />)}
      >
        <div className={s.wrap}>
          <div className={s.now}>
            <div className={s.nowK}>{t('tms.dutyNow')}</div>
            <b>{t('tms.dutyAdmin')}</b>
            <div className={s.nowV}>{t('tms.dutyNext')}</div>
          </div>
          <div className={s.seg} role="group" aria-label="Chọn tuần">
            {DUTY_WEEKS.map((w) => (
              <button key={w.key} type="button" aria-pressed={wk === w.key} onClick={() => setWk(w.key)}>{w.label}</button>
            ))}
          </div>
          <div className={s.list}>
            {days.map(([d, v, tag]) => (
              <div key={d} className={`${s.day} ${tag ? s.dayOn : ''}`}>
                <span className={s.dayK}>{d}</span>
                <span className={s.dayV}>{v}</span>
                {tag && <span className={s.tag}>{tag}</span>}
              </div>
            ))}
          </div>
          <div className={s.ot}>
            <div className={s.otHd}>
              <b title={DUTY_OT.tip}>{t('tms.otOct')}</b>
              <span><b>6,5h</b> <span className={s.lb}>/ 40h</span></span>
            </div>
            <div className={s.bar}><i style={{ width: `${dutyOtPct()}%` }} /></div>
            <div className={s.otFt}>{`${DUTY_OT.shifts} ca trực · phụ cấp trực theo ca`}</div>
          </div>
          <button type="button" className={s.swap} onClick={() => toast({ msg: 'Đã gửi yêu cầu đổi ca cho PHONG · chờ [OPS-HEAD] duyệt' })}>
            <IconSend size={16} stroke={1.8} aria-hidden="true" />
            {t('tms.swapShift')}
          </button>
        </div>
      </StateView>
    </Page>
  );
}
